import type { AxiosInstance } from 'axios'

import type { LiveKeyEventPayload } from '../models/conversion.types'

import { DEFINITIONS_REQUEST_CONFIG } from './config'

import { appHttp, unwrap, unwrapEnvelope, type ApiEnvelope } from '@/shared/http'

export class ConversionApi {
  constructor(private readonly http: AxiosInstance = appHttp) {}

  async getMmpKeyEvents(
    accountId: number | string,
    workspaceId: number | string,
    platform: 'adjust' | 'appsflyer',
  ): Promise<LiveKeyEventPayload> {
    return unwrapEnvelope(
      await this.http.get<ApiEnvelope<LiveKeyEventPayload>>(
        `/accounts/${accountId}/workspaces/${workspaceId}/settings/mmp-key-event-by-api/?platform=${platform}`,
        DEFINITIONS_REQUEST_CONFIG,
      ),
    )
  }

  async getGa4KeyEvents(
    accountId: number | string,
    workspaceId: number | string,
  ): Promise<LiveKeyEventPayload> {
    return unwrapEnvelope(
      await this.http.get<ApiEnvelope<LiveKeyEventPayload>>(
        `/accounts/${accountId}/workspaces/${workspaceId}/settings/key-event-by-api/`,
        DEFINITIONS_REQUEST_CONFIG,
      ),
    )
  }

  async getHardalEventNames(workspaceId: number | string): Promise<string[]> {
    return (
      unwrap(
        await this.http.get<string[]>(
          `/integrations/${workspaceId}/get-hardal-event-names`,
          DEFINITIONS_REQUEST_CONFIG,
        ),
      ) ?? []
    )
  }
}

export const conversionApi = new ConversionApi()
